import styled from '@emotion/styled';
import { Button } from '~/shared/components/Button';
import { Form } from '~/shared/components/Form';
import { Text } from '~/shared/components/Text';

export const Paragraph = styled.p<{ dimmed?: boolean }>(({ theme }) => ({
    display: 'block',
    color: theme.colors.thunderBlack,
    fontSize: theme.fontSizes.guinea,
    lineHeight: theme.lineHeights.chicken,
    maxWidth: 800,
}));

export const InputSection = styled.div(() => ({
    height: '100%',
    gridRow: '1 / 2',
}));

export const StyledForm = styled(Form)(({ theme }) => ({
    height: '100%',
    marginTop: theme.space[4],
    display: 'grid',
    gridTemplateRows: 'auto auto 1fr',
    gap: theme.space[6],
    paddingBottom: theme.space[1],
    button: {
        alignSelf: 'end',
        svg: {
            path: {
                fill: 'none',
            },
        },
    },
}));

export const StyledText = styled(Text)(({ theme }) => ({
    marginBottom: theme.space[4],
}));

export const StyledButton = styled(Button)(({ theme }) => ({
    marginBottom: theme.space[4],
    color: theme.colors.black,
}));

export const StyledWrapper = styled.div(({ theme }) => ({
    display: 'grid',
    maxWidth: 450,
    width: '100%',
    rowGap: theme.space[4],
    paddingTop: theme.space[7],
    paddingBottom: theme.space[4],
}));

export const HeaderWrapper = styled.div((props) => ({
    display: 'flex',
    flexWrap: 'wrap',
}));

export const SpacedText = styled(Text)(({ theme }) => ({
    marginRight: theme.space[2],
}));

export const WordBreakText = styled(Text)((props) => ({
    wordBreak: 'break-all',
}));

export const ButtonWrapper = styled.div(({ theme }) => ({
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: theme.space[2],
    marginTop: theme.space[6],

    button: {
        flex: 1,
    },

    '& > button:first-of-type': {
        color: theme.colors.black,
    },
}));
